import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const InventoryDeleteModal = (props) => {
  let msgInput = {marginTop: '10px', width: '100%', opacity: '0.6', padding: '6px 15px', height: '65px'}
  let backgroundHeader = {background: '#ff5454'}
  let subtitle = {color: 'dimgray', marginBottom: '5px'}
    return(
      <Modal isOpen={props.isModalOpen} toggle={props.closeModal} className={'modal-warning modal-logut'}>
        <ModalHeader toggle={props.closeModal} style={backgroundHeader}>{props.header}</ModalHeader>
        <ModalBody>
          <div style={subtitle}>
            <span>{props.subtitle}</span>
          </div>
          <div>
            <div>
              <span>{props.selectTitle}</span>
              <select id="select" name="select" className={`form-control w-100 pl-1`} size="1" onChange={props.onSelectChange} value={props.value}>
                <option value="-1">{props.emptySelectMsg}</option>
                {props.list.map((l,idx) => {
                      return(<option value={idx} key={idx}>{l.name}</option>)
                    })
                }
              </select>
            </div>
            <span>{props.textAreaTitle}</span>
            <div className="custom-textarea">
              {props.textInput ? <textarea name="msg-input" style={msgInput} placeholder={props.textPlaceholder} value={props.message} onChange={(msg) => {props.onMessageChange(msg)}}/> : ''}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={props.disableOnConfirm} onClick={props.onConfirm}>{props.onConfirmButtonText}</Button>
          <Button color="secondary" onClick={props.onCancel}>{props.onCancelButtonText}</Button>
        </ModalFooter>
      </Modal>
    )
}
export default InventoryDeleteModal
